import React from "react";
import WithdrawlHome from "./withDrawHome";
import WithDrawHistory from "./withdrawHistory";

function Withdraw() {
  return (
    <div>
      <WithdrawlHome />
      <h1>Hellow users</h1>
    </div>
  );
}

export default Withdraw;
